module.exports = __webpack_public_path__ + "img/Drop_down.9295ee3f.svg";